import React from "react";
import { Link } from "react-router-dom";
import { useFetch, useSiteData } from "../lib/hooks";
import { fileUrl } from "../lib/api";
import { Reveal, Overline } from "../components/site/Reveal";
import PageHeader from "../components/site/PageHeader";
import { Check, ArrowRight } from "lucide-react";

const IMG = (s, k) => fileUrl(s?.images?.[k]);

export default function Catering() {
  const s = useSiteData();
  const { data: packages } = useFetch("/public/packages");
  const services = [
    ["Buffet", "buffet"], ["Plated Service", "chef"], ["Live Counters", "flame"],
    ["Food Stations", "spread"], ["Packed Meals", "corp_boxes"], ["Bulk Food", "corporate"],
  ];
  return (
    <div>
      <PageHeader overline="Catering Services" title={<>Catering, crafted <span className="italic gold-text">around you.</span></>}
        subtitle="Choose a signature package or design your own — buffets, plated dinners, live counters and beyond." image={IMG(s, "buffet")} />

      <section className="py-24 bg-ivory">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
          <Reveal className="mb-12"><Overline>Service Styles</Overline>
            <h2 className="font-serif text-burgundy text-4xl sm:text-5xl mt-4">However you like to serve.</h2></Reveal>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
            {services.map(([t, k], i) => (
              <Reveal key={t} delay={(i % 3) * 0.08}>
                <div className="group relative overflow-hidden rounded-2xl aspect-[4/3]">
                  <img src={IMG(s, k)} alt={t} className="w-full h-full object-cover img-zoom brightness-90" />
                  <div className="absolute inset-0 bg-gradient-to-t from-velvet/80 to-transparent" />
                  <h3 className="absolute bottom-5 left-5 font-serif text-ivory text-2xl">{t}</h3>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-cream">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
          <Reveal className="text-center mb-14"><Overline className="justify-center">Menu Packages</Overline>
            <h2 className="font-serif text-burgundy text-4xl sm:text-5xl mt-4">Signature catering packages.</h2></Reveal>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {packages.map((p, i) => (
              <Reveal key={p.id} delay={(i % 4) * 0.08}>
                <div className="bg-ivory border border-gold/25 rounded-2xl overflow-hidden h-full flex flex-col hover:shadow-2xl transition-shadow">
                  <div className="aspect-[16/10] overflow-hidden group"><img src={fileUrl(p.image)} alt={p.name} className="w-full h-full object-cover img-zoom" /></div>
                  <div className="p-6 flex flex-col flex-1">
                    <h3 className="font-serif text-2xl text-burgundy leading-tight">{p.name}</h3>
                    <p className="text-charcoal/55 text-sm mt-1 mb-4">{p.description}</p>
                    <div className="mb-4"><span className="font-serif text-3xl gold-text">₹{p.price_per_person}</span><span className="text-charcoal/50 text-sm"> / person</span>
                      <p className="text-[0.7rem] text-charcoal/40 mt-1">Min {p.min_guests} guests</p></div>
                    <ul className="space-y-2 text-sm text-charcoal/70 flex-1">
                      {(p.features || []).map((f) => <li key={f} className="flex gap-2"><Check className="w-4 h-4 text-gold shrink-0 mt-0.5" />{f}</li>)}
                    </ul>
                    <Link to={`/contact?package=${encodeURIComponent(p.name)}`} className="btn-burgundy mt-6 justify-center text-xs" data-testid={`package-enquire-${i}`}>Enquire</Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-burgundy grain text-center">
        <div className="max-w-2xl mx-auto px-4">
          <h2 className="font-serif text-ivory text-4xl sm:text-5xl mb-6">Prefer a custom quote?</h2>
          <Link to="/quote-builder" className="btn-gold">Build Your Menu <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </div>
  );
}
